import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchJSON } from '../../../../../../../../../../utils/hooks/useFetchJson'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalRecalculateSellDeliveryNoteProps extends ModalEditComponentProps {}

const ModalRecalculateSellDeliveryNote: React.FC<ModalRecalculateSellDeliveryNoteProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchJSON } = useFetchJSON({
        onSubmit,
        url: '/api/app/order/sell/sellDeliveryNote/recalculatePricesSellDeliveryNote',
        data: allRowData?.header || {}
    })
    const { handleFetchJSONLoading, loading } = useModalRecalculateSellDeliveryNoteLogic({ handleFetchJSON })
    return (
        <ModalSmallFilled opened={true} loading={loading} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchJSONLoading} translations={{
            title: t('sureRecalculateSellDeliveryNote', '¿Seguro que quieres recalcular este albarán de venta?'),
            subtitle: t('recalculateProductPrices', 'Recalculará los precios de los productos'),
            buttonAccept: t('accept', 'Aceptar'),
        }} />
    )
}


interface ModalRecalculateSellDeliveryNoteLogicProps {
    handleFetchJSON: () => Promise<void>
}

const useModalRecalculateSellDeliveryNoteLogic = ({handleFetchJSON}: ModalRecalculateSellDeliveryNoteLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const handleFetchJSONLoading = useCallback(async() => {
        startLoading()
        await handleFetchJSON()
        endLoading()
    }, [startLoading, handleFetchJSON, endLoading])
    return { handleFetchJSONLoading, loading }
}

export default ModalRecalculateSellDeliveryNote